export const POLICIES_LIST = {
  SIGN_TEXT: 'I have read and agree to this policy',
  TITLE: 'Policies',
  SIGN_BUTTON: 'Sign',
  SIGNED_TEXT: (date: Date | null) => {
    const dateString = date ? `on ${date.toLocaleDateString()}` : ''
    return `You have already signed the policies ${dateString}`
  },
  SIGN_ALL_TEXT: 'I have read and agree to all policies',
}
